{
  "version": 1,
  "asset_id": "5706df0a-4d88-4365-992e-9774de8211af",
  "project_id": "ace3bf0c-1a84-4f82-9ad2-9a17469468c9",
  "url": "prico_logo_square.png",
  "r2_key": "a/v1/ace3bf0c-1a84-4f82-9ad2-9a17469468c9/5706df0a-4d88-4365-992e-9774de8211af/prico_logo_square.png",
  "original_filename": "prico_logo_square.png",
  "size": 25216,
  "content_type": "image/png",
  "created_at": "2026-06-15T19:17:13Z"
}